import React, { Component } from 'react';

class Domains extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			editingSetting: false,
			loading: false,
		};
	}

	impersonate = (domain) => (e) => {
		this.props.ws.send(JSON.stringify({ route: 'impersonate', domain: domain }))
	}

	render() {
		if (this.props.active) {
			var domList = []
			for (var dom of this.props.data.Domains) {
				domList.push(
					<div className="dataRow" key={dom} onClick={this.impersonate(dom)} >
						<span style={{ flex: '0 0 300px' }} >{dom}</span>
					</div>
				)
			}
			return (
				<div width="100%">
					<div className="dataHeaders">
						<span style={{ flex: '0 0 300px', cursor: 'pointer' }}>Domain</span>
						<span style={{ flex: '1 0 20%', cursor: 'pointer' }}>Description</span>
					</div>
					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{domList}
					</div>
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuWorld"
const roles = ["View", "Add", "Edit", "Delete", "Impersonate"]
export { Domains, icon, roles }


// WEBPACK FOOTER //
// ./src/Views/Domains.js